import React, { memo } from 'react';
import { C } from '../../constants';
import { getInitials, getAvatarColor, timeAgo } from '../../utils';

const ConversationList = memo(function ConversationList({ conversations, selectedUser, onSelect }) {
  if (conversations.length === 0) return (
    <div style={{ padding:'40px 16px', textAlign:'center' }}>
      <p style={{ fontSize:'32px', marginBottom:'10px' }}>💬</p>
      <p style={{ color:C.textMuted, fontSize:'13px' }}>Sin mensajes aún</p>
    </div>
  );
  return (
    <div style={{ display:'flex', flexDirection:'column' }}>
      {conversations.map(c => {
        const av = getAvatarColor(c.user_name);
        const isSelected = selectedUser?.user_id === c.user_id;
        return (
          <div key={c.user_id} onClick={() => onSelect(c)} style={{ padding:'12px 16px', cursor:'pointer', background: isSelected ? C.bgCard : 'transparent', borderBottom:`1px solid ${C.border}`, display:'flex', alignItems:'center', gap:'10px', transition:'background 0.15s', borderLeft: isSelected ? `3px solid ${C.accent}` : '3px solid transparent' }}>
            <div style={{ position:'relative', flexShrink:0 }}>
              <div style={{ width:'38px', height:'38px', borderRadius:'50%', background:av.bg, color:av.text, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'13px', fontWeight:'600' }}>{getInitials(c.user_name)}</div>
              <span style={{ position:'absolute', bottom:'1px', right:'1px', width:'9px', height:'9px', borderRadius:'50%', background: c.is_online ? C.online : C.textDim, border:`2px solid ${C.bgModal}` }} />
            </div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <p style={{ color:C.text, fontSize:'13px', fontWeight:'500', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{c.user_name}</p>
                <span style={{ color:C.textDim, fontSize:'10px', flexShrink:0, marginLeft:'6px' }}>{timeAgo(c.last_at)}</span>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:'4px', marginTop:'2px' }}>
                {c.unread_count === 0 && c.last_message && <span style={{ fontSize:'11px', color: c.last_msg_read ? '#5dade2' : C.textDim, fontWeight:'600', flexShrink:0 }}>{c.last_msg_read ? '✓✓' : '✓'}</span>}
                <p style={{ color:C.textMuted, fontSize:'12px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{c.last_message || 'Sin mensajes'}</p>
              </div>
              {c.is_online && c.watching_now && <p style={{ color:C.accentSoft, fontSize:'10px', marginTop:'2px' }}>▶ {c.watching_now.replace(/\.[^.]+$/, '')}</p>}
            </div>
            {c.unread_count > 0 && <div style={{ width:'18px', height:'18px', background:C.accent, borderRadius:'50%', fontSize:'10px', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'700', flexShrink:0 }}>{c.unread_count > 9 ? '9+' : c.unread_count}</div>}
          </div>
        );
      })}
    </div>
  );
});

export default ConversationList;
